import { useCallback } from 'react';
import { useCountryCodeValue, useIpValue } from './system/useCountryCode';
import { useOrgConfigStateValue } from './useOrgConfig';
import { logger } from 'services/logger';
import { getProxyOriginSrc, isTiktokProxySrc } from 'lib/utils/platformImage';

function useProxySrc() {
  const countryCode = useCountryCodeValue();

  const ip = useIpValue();

  const { tiktokImageProxyOriginList } = useOrgConfigStateValue();

  const getProxyEnable = useCallback(
    (src: string) => {
      try {
        const { origin } = new URL(src);
        return countryCode === 'CN' && tiktokImageProxyOriginList?.some((_) => origin.includes(_));
      } catch (_) {
        return false;
      }
    },
    [countryCode, tiktokImageProxyOriginList],
  );

  const errorLog = useCallback(
    (src: string) => {
      const originSrc = isTiktokProxySrc(src) ? getProxyOriginSrc(src) : src;
      logger.info(
        `[loadImageError] ${JSON.stringify({
          ip,
          countryCode,
          src,
          originSrc,
        })}`,
      );
    },
    [ip, countryCode],
  );

  return { getProxyEnable, errorLog };
}

export default useProxySrc;
